export default function LocationIcon({ svgClass }) {
  return (
    <svg
      className={svgClass}
      xmlns='http://www.w3.org/2000/svg'
      width='21.16'
      height='30.36'
      viewBox='0 0 21.16 30.36'>
      <path
        id='_Locantion_icon'
        data-name=' Locantion icon'
        d='M10.58,30.36h0A68.954,68.954,0,0,1,5.29,23.482C2.877,19.889,0,14.743,0,10.626a10.58,10.58,0,1,1,21.16,0c0,4.117-2.877,9.263-5.29,12.855a68.954,68.954,0,0,1-5.289,6.877Zm0-23.529a3.8,3.8,0,1,0,3.779,3.8A3.791,3.791,0,0,0,10.58,6.831Z'
        fill='#fff'
      />
    </svg>
  );
}
